import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Select from 'react-select';
import actions from 'actions';

const {
  loadCountriesSaga
} = actions;

class CountryInput extends Component {
  static propTypes = {
    dispatch: PropTypes.func.isRequired,
    loadCountries: PropTypes.func,
    value: PropTypes.string,
    onChange: PropTypes.func,
    errors: PropTypes.array,
    countries: PropTypes.array,
    label: PropTypes.string,
    placeholder: PropTypes.string,
    selectProps: PropTypes.object
  };

  static defaultProps = {
    label: ''
  }

  constructor(props) {
    super(props);
  }

  componentWillMount() {
    this.props.loadCountries();
  }

  render() {
    const {
      value,
      onChange,
      errors,
      countries,
      label,
      placeholder = 'Country',
      selectProps = {}
    } = this.props;
    return (
      <div className="col s12">
        <p className="input_country">{label}</p>
        <Select
          options={countries}
          placeholder={placeholder}
          value={value}
          onChange={onChange}
          {...selectProps}
        />
        <div style={{ color: 'red', fontSize: '0.875rem' }}>
          {(errors || []).join('. ')}
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    countries: state.suggestions.country.values
  };
}

function mapDispatchToProps(dispatch) {
  return {
    loadCountries: () => dispatch(loadCountriesSaga())
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(CountryInput);



// WEBPACK FOOTER //
// ./src/containers/Input/CountryInput.jsx